<div class="lmo-driver-list-component">
  <div class="heading flex flex-row justify-between">
    <h2>Drivers</h2>
  </div>
  <div>
    <div class="w-full flex flex-row items-center gap-1">
      <i class="material-icons">
        search
      </i>
      <mat-form-field class="w-full">
        <input matInput type="text" placeholder="Search" autofocus [formControl]="driverSearchControl" />
      </mat-form-field>
    </div>
    <table class="drivers-table" (matSortChange)="sortChanged($event)" matSort>
      <tr>
        <th class="table-header" mat-sort-header="name">Name</th>
        <th class="table-header" mat-sort-header="phone">Phone</th>
        <th class="table-header" mat-sort-header="carrier">Carrier</th>
        <th class="table-header" mat-sort-header="subcarrier">Subcarrier</th>
        <th></th>
      </tr>
      <tbody class="table-body">
        <tr *ngFor="let driver of drivers$ | async; trackBy: drivers$ | trackByKey: 'id'" class="row">
          <td class="cell">{{ driver.name }}</td>
          <td class="cell">{{ driver.phone }}</td>
          <td class="cell">{{ driver.carrier }}</td>
          <td class="cell">{{ driver.subcarrier }}</td>
          <td class="cell text-center">
            <ng-container *ngIf="driver.canBeBanned; else cannotBeBanned">
              <ng-container *saUserPermission="'ban_drivers'">
                <button *ngIf="!driver.banId" mat-flat-button color="primary" (click)="promptBanDriver(driver)">
                  Suspend
                </button>
                <span
                  *ngIf="driver.banId"
                  class="text-red-500 font-semibold"
                  [matTooltip]="'View Suspended Drivers List to Reinstate'"
                >
                  Suspended
                </span>
              </ng-container>
            </ng-container>
            <ng-template #cannotBeBanned>
              <i class="material-icons text-gray-700" [matTooltip]="'No valid CDL or phone number'">
                do_not_disturb
              </i>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="footer">
      <mat-paginator
        (page)="switchPage($event)"
        [length]="total$ | async"
        [pageIndex]="(page$ | async) - 1"
        [pageSize]="pageSize$ | async"
        [pageSizeOptions]="[10, 25, 50]"
        #paginator
      ></mat-paginator>
    </div>
  </div>
</div>
